{
    "about": {
        "meta": {
            "title": "Quiénes somos - MAJORITY",
            "description": "¿Deseas saber más sobre MAJORITY? Brindamos a los migrantes las herramientas, los recursos y el apoyo para prosperar en un nuevo país. ¡Conoce más!"
        },
        "our_mission": {
            "hey_there": "¡HOLA!",
            "we_are_majority": "Somos MAJORITY. Nuestra misión es brindarle a los migrantes las mejores herramientas, los recursos y el apoyo para triunfar en su nuevo país. ¡Porque creemos que todos merecen la oportunidad de salir adelante!"
        },
        "join_us": {
            "title": "Únete a nuestro equipo",
            "we_are_description": "Somos un grupo orgullosamente diverso con migrantes de más de 40 nacionalidades distintas. Trabajamos juntos para crear productos de valor que permitan acortar distancias culturales y geográficas. Si te interesa, ¡contáctanos!",
            "languages": "Idiomas",
            "nacionalities": "Nacionalidades",
            "individuals": "Individuos",
            "see_all_jobs": "Ver todos los trabajos"
        },
        "career": {
            "meta": {
                "title": "Bolsa de trabajo",
                "description": "Somos un grupo orgullosamente diverso con migrantes de más de 40 nacionalidades distintas. Trabajamos juntos para crear productos de valor que permitan acortar distancias culturales y geográficas. Si te interesa, ¡contáctanos!"
            },
            "meta_apply": {
                "description": "¿Quieres trabajar con nosotros? ¡Nos encantaría saber de ti!"
            },
            "hero_title": "Vacantes",
            "hero_description": "¡Llamando a todos los líderes influyentes! Vamos a hacer algo genial juntos.",
            "open_positions": "Puestos disponibles",
            "show_jobs_in": "Mostrar trabajos en:",
            "job_location_all": "Todas las ubicaciones",
            "department": "Departamento:",
            "location": "Ubicación:",
            "apply_now": "Aplicar ahora"
        },
        "press": {
            "title": "¿Tienes una pregunta de medios?",
            "description": "¡Vamos a conectar! Envía un correo electrónico a <a class=\"{variant}\" href=\"mailto:{email}\">{email}</a>",
            "button": "Descargar kit de prensa"
        }
    }
}